export enum VerticalAlignmentStyle {
    top = 0,
    middle = 1,
    bottom = 2
}
